import tradingPlatformsContent from './content/trading-platforms.json';

const tradingPlatformsMock = {
    layoutType: 2,
    data: {
        name: 'trading-platforms',
        layoutType: 2,
        areasList: [
            {
                id: 'trading-platforms-page-area',
                name: 'Content',
                componentName: 'Comp:TradingPlatformsPage',
                content: JSON.stringify(tradingPlatformsContent),
            },
        ],
    },
};

export default tradingPlatformsMock;
